export async function eventPluginTest(e) {
  console.log("e :>> ", e)
}
// 用于跨页面传参的事件插件
export async function storagePlugin(from, to, currEventDes) {
  const url = currEventDes.url
  let valuePath = "value"
  const execVariablePath = Object.keys(currEventDes.variableTag).map(k => currEventDes.variableTag[k].path)
  if (execVariablePath.length > 0) {
    /* 默认取监听的第一个变量数据 */
    valuePath = execVariablePath[0]
  }
  if (!url?.length && from?.options?.value) return
  window.localStorage.setItem("pageQuery", from.options[valuePath])
}
// 用于多级传参：
export async function eventPluginMultiSw(from, to, currEventDes) {
  if(!to){
    return
  }
  let fromRectId = from.ids?.rect_id
  let stateObj = from.$store.state
  let name = to.request_prefix
  let eventArrOld = to.$event.eventBus.stage
  if (name === "appHome") {
    eventArrOld = to.$event.eventBus.appStage
  }
  //  查找有同样插件的组件并获取值
  let valueArr = [],
    rectIdArrAll = [],
    rectIdArr = [],
    rectIdArrSort = [],
    eventArrKeyLists = [],
    eventArr = {},
    datePickerIndex = -1

  /* 事件遍历根据rect_id来排序 */
  for (let key in eventArrOld) {
    eventArrKeyLists.push(key)
    let str1 = key.split("_")
    let lastId = str1[str1.length - 1]
    rectIdArrAll.push(lastId)
  }
  rectIdArrSort = [...rectIdArrAll].sort()
  for (let i = 0; i < rectIdArrSort.length; i++) {
    let index1 = rectIdArrAll.indexOf(rectIdArrSort[i])
    eventArr[eventArrKeyLists[index1]] = eventArrOld[eventArrKeyLists[index1]]
  }
  for (let key in eventArr) {
    /* 交互事件搭建需要指定为变量发生改变 */
    let event1 = eventArr[key].events.dataEvents.appointDataChange
    if (JSON.stringify(event1).indexOf("eventPluginMultiSw") !== -1) {
      let ids1 = eventArr[key].publishComponentIds
      let hasSameTo = false
      for (let j = 0; j < event1.length; j++) {
        if (event1[j].ids?.rect_id === to.ids?.rect_id || event1[j].ids?.rect_id === to.myid?.rect_id) {
          hasSameTo = true
        }
      }
      /* 排除触发组件以及不同的响应组件 */
      if (hasSameTo) {
        rectIdArr.push(ids1.rect_id)
        let option1 = to.getAttrById(stateObj[name], ids1)
        const { componentVariables } = eventArr[key]
        let valuePath = "value"
        if (componentVariables.length > 0) {
          /* 默认取监听的第一个变量数据 */
          valuePath = componentVariables[0].variablePath
        }
        if (option1 && option1.options && Array.isArray(option1.options.value) && valuePath !== "value") {
          let str1 = ""
          for (let i = 0; i < option1.options.value.length; i++) {
            /* 日期组件的时刻范围选择 */
            if (option1.options.innerElement === "cxDatePicker" && option1.options.dateType.indexOf("range") > -1) {
              //先处理时间为标准格式时情况
              let ifDefault = false
              if (Object.prototype.toString.call(option1.options.value[i]) === "[object Date]") {
                ifDefault = true
                let time = new Date(option1.options.value[i])
                let month =
                  Number(time.getMonth() + 1) < 10 ? "0" + Number(time.getMonth() + 1) : Number(time.getMonth() + 1)
                let day = time.getDate() < 10 ? "0" + time.getDate() : time.getDate()
                if (option1.options.dateType === "monthrange") {
                  str1 = str1 + (i === 0 ? "" : "#") + time.getFullYear() + "-" + month
                } else if (option1.options.dateType === "daterange") {
                  str1 = str1 + (i === 0 ? "" : "#") + time.getFullYear() + "-" + month + "-" + day
                } else if (option1.options.dateType === "datetimerange") {
                  str1 = str1 + (i === 0 ? "" : "#") + time.getFullYear() + "-" + month + "-" + day + " " + "00:00"
                }
              }
              if (option1.options.dateFormat.indexOf("ss") > -1 && !ifDefault) {
                let mmEndIndex = option1.options.dateFormat.indexOf("mm") + 2
                let ssLength = option1.options.dateFormat.length - mmEndIndex
                let range = ssLength > 0 ? option1.options.value[i].slice(0, -ssLength) : option1.options.value[i]
                str1 = str1 + (i === 0 ? "" : "#") + range
              } else if (option1.options.dateFormat.indexOf("ss") < 0 && !ifDefault) {
                str1 = str1 + (i === 0 ? "" : "#") + option1.options.value[i]
              }
              datePickerIndex = rectIdArr.indexOf(ids1.rect_id)
              console.log('datePickerIndex', datePickerIndex)
            } else {
              str1 = str1 + (i === 0 ? "" : "#") + option1.options.value[i]
            }
          }
          valueArr.push(str1)
        } else if (option1 && option1.options && option1.options[valuePath]) {
          valueArr.push(option1.options[valuePath])
        } else {
          valueArr.push("")
        }
      }
    }
  }
  let valueArrCopy = [...valueArr]
  if (valueArr.length > 0) {
    let newStr = ""
    if (from.options.innerElement === "cxDatePicker" || datePickerIndex >= 0) {
      valueArr.splice(datePickerIndex, 1)
      valueArr.push(valueArrCopy[datePickerIndex])
    }
    valueArr = valueArr.filter(item => item !== "") //过滤掉空字符
    if (valueArr.length > 0) {
      for (let i = 0; i < valueArr.length; i++) {
        newStr = newStr + (i === 0 ? "" : "###") + valueArr[i]
      }
    }
    let idsCopy = to.ids
    if (!to.ids || !to.ids.rect_id) {
      idsCopy = to.myid
    }
    to.$store.dispatch(to.request_prefix + "/changeOptions", {
      ...idsCopy,
      option_name: "eventQuery",
      // option_val: queryStrFirst ? newStr + to.options.eventQuery : to.options.eventQuery + newStr
      option_val: newStr
    })
  }
}

//交互事件进入页面立即执行监听的事件
export async function immediateTrue(from) {
  /*  注意：插件写在事件触发前 */
  if (from.options.innerElement === "cxDatePicker" && from.value) {
    let str = []
    //日期范围选择
    if (from.options.dataPickerType === 3) {
      if (from.options.startDate) {
        str = from.options.startDate
      } else {
        for (let i = 0; i < from.value.length; i++) {
          let time = from.options.value[i]
          if (Object.prototype.toString.call(from.options.value[i]) === "[object Date]") {
            let month =
              Number(time.getMonth() + 1) < 10 ? "0" + Number(time.getMonth() + 1) : Number(time.getMonth() + 1)
            let day = time.getDate() < 10 ? "0" + time.getDate() : time.getDate()
            let hour = time.getHours() < 10 ? "0" + time.getHours() : time.getHours()
            time = time.getFullYear() + "-" + month + "-" + day + " " + hour + ":00"
            str = str + (i === 0 ? "" : "#") + time
          } else {
            str = str + (i === 0 ? "" : "#") + from.options.value[i]
          }
        }
      }
    } else {
      if (Object.prototype.toString.call(from.options.value) === "[object Date]") {
        let time = from.options.value
        let month = Number(time.getMonth() + 1) < 10 ? "0" + Number(time.getMonth() + 1) : Number(time.getMonth() + 1)
        let day = time.getDate() < 10 ? "0" + time.getDate() : time.getDate()
        let hour = time.getHours() < 10 ? "0" + time.getHours() : time.getHours()
        str = time.getFullYear() + "-" + month + "-" + day + " " + hour + ":00"
      } else {
        str = from.options.value
      }
    }
    from.$store.dispatch(from.request_prefix + "/changeOptions", {
      ...from.ids,
      option_name: "startDate",
      option_val: str
    })
  }
}

//模拟点击响应组件
export async function eventDialogClick(from, to) {
  to.$el.click()
}

// 用于跨页面多级传参的事件插件
export async function multiStoragePlugin(from, to, currEventDes, eventBus) {
  let fromRectId = from.ids.rect_id
  let stateObj = from.$store.state
  let eventArr = eventBus.stage
  let name = "bigScreen"
  //  查找有同样插件的组件并获取值
  let valueArr = []
  for (let key in eventArr) {
    /* 交互事件搭建需要指定为变量发生改变 */
    let event1 = eventArr[key].events.dataEvents.appointDataChange
    if (JSON.stringify(event1).indexOf("multiStoragePlugin") !== -1) {
      let ids1 = eventArr[key].publishComponentIds
      /* 排除触发组件以及不同的响应组件 */
      if (fromRectId !== ids1.rect_id) {
        let option1 = from.getAttrById(stateObj[name], ids1)
        const { componentVariables } = eventArr[key]
        let valuePath = "value"
        if (componentVariables.length > 0) {
          /* 默认取监听的第一个变量数据 */
          valuePath = componentVariables[0].variablePath
        }
        if (option1.options[valuePath]) {
          valueArr.push(option1.options[valuePath])
        }
      }
    }
  }
  let newStr = ""
  if (valueArr.length > 0) {
    for (let i = 0; i < valueArr.length; i++) {
      newStr = newStr + "###" + valueArr[i]
    }
  }
  const execVariablePath = Object.keys(currEventDes.variableTag).map(k => currEventDes.variableTag[k].path)
  let strValue = from.options[execVariablePath[0]] + newStr
  const url = currEventDes.url
  if (!url?.length && from?.options?.value) return
  window.localStorage.setItem("pageQuery", strValue)
}

// 用于同页面弹框传参的事件插件
export async function storageDialogPlugin(from, to, currEventDes) {
  let valuePath = "value"
  const execVariablePath = Object.keys(currEventDes.variableTag).map(k => currEventDes.variableTag[k].path)
  if (execVariablePath.length > 0) {
    /* 默认取监听的第一个变量数据 */
    valuePath = execVariablePath[0]
  }
  if (!from?.options[valuePath]) return
  window.localStorage.setItem("pageQuery", from.options[valuePath])
  window.localStorage.setItem("sameUrlQuery", 1)
}

// 修改事件:自由布局接收参数，滚动行数数据错误导致滚动渲染高度错误，数据重叠在一起
export async function changeEventLayoutScroll(from, to, currEventDes) {
  let idsCopy = to.ids
  if (!to.ids || !to.ids.rect_id) {
    idsCopy = to.myid
  }
  to.$store.dispatch(to.request_prefix + "/changeOptions", {
    ...idsCopy,
    option_name: "eventClearOption",
    option_val: true
  })
}
